export default "__VITE_ASSET__Du0Dz1Ea__"